import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'

const options = {
  confirmButtonColor: '#4caf50',
  cancelButtonColor: '#ff5252'
}

Vue.use(VueSweetalert2, options)
